import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';

class Tabs extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    onChange: PropTypes.func.isRequired,
    activeKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    className: PropTypes.string,
  };

  static defaultProps = {
    className: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      activeKey: this.props.activeKey,
    };
  }

  componentDidMount() {
    const tabMenu = ReactDOM.findDOMNode(this.refs.tabMenu);
    const { activeKey } = this.state;
    const linkArray = tabMenu.querySelectorAll('a');

    // add necessary classes
    Array.prototype.forEach.call(linkArray, el => {
      const tabLinkClass = [el.className.trim(), 'tabMenu-link'];
      if (el.getAttribute('data-eventkey') === activeKey) {
        tabLinkClass.push('is-active');
      }

      el.className = classNames(tabLinkClass);
    });

    // bind click events to change active tab
    tabMenu.addEventListener('click', e => {
      if (!e.target.getAttribute('data-eventkey')) {
        return;
      }
      const target = e.target;
      const eventKey = target.getAttribute('data-eventkey');
      // change is-active class acordingly
      Array.prototype.forEach.call(linkArray, el => {
        el.className = el.className.replace('is-active', '');
      });

      console.log('target.className', target.className);
      target.className = classNames(target.className.trim(), {
        'is-active': true,
      });

      this.setState({ activeKey: eventKey }, () => {
        this.props.onChange(eventKey);
      });
    });
  }

  render() {
    const { activeKey } = this.state;
    let tabContent = this.props.children.map((child, idx) => {
      let renderFinal = null;
      if (child === null) {
        renderFinal = null;
      } else {
        renderFinal = (
          <div
            key={'tab_' + idx}
            style={{ display: child.props.eventKey === activeKey ? 'block' : 'none' }}>
            {child.props.children}
          </div>
        );
      }
      return renderFinal;
    });

    return (
      <div className={this.props.className}>
        <div className="tabMenu" ref="tabMenu">
          {this.props.children && this.props.children.length > 1 ? this.props.children : null}
        </div>
        <div className="tabContent">{tabContent}</div>
      </div>
    );
  }
}

export default Tabs;
